import { autogeneratedTools } from "../generated/webmcp/tools";

let allToolsController: AbortController | null = null;

export const unregisterAllWebMcpTools = () => {
  if (allToolsController) {
    allToolsController.abort();
    allToolsController = null;
  }
  if (!import.meta.env.DEV) {
    return;
  }
  delete window.__dart_mcp;
};

export const registerAllWebMcpTools = () => {
  const { modelContext } = document;
  if (modelContext && !allToolsController) {
    const controller = new AbortController();
    const options = { signal: controller.signal };
    try {
      autogeneratedTools.forEach((tool) => {
        modelContext.registerTool(
          {
            name: tool.name,
            description: tool.description,
            inputSchema: tool.inputSchema,
            execute: (args) => tool.execute(args as Record<string, unknown>),
          },
          options
        );
      });
      allToolsController = controller;
    } catch (ex) {
      controller.abort();
      throw ex;
    }
  }

  if (!import.meta.env.DEV) {
    return;
  }

  window.__dart_mcp = {
    tools: Object.fromEntries(autogeneratedTools.map((t) => [t.name, t])),
    callTool: async (name: string, args: Record<string, unknown> = {}) => {
      const tool = autogeneratedTools.find((t) => t.name === name);
      if (!tool) {
        return { error: `Unknown tool: ${name}` };
      }
      return tool.execute(args);
    },
  };
};
